"use strict";

const util = require("js/util.js");

/* Prevent opening new popup in same moment of loading another card,
    popup shall open when "mouseenter" after a timeout */
let preventOpening = false;

class BoundPopupFor extends HTMLElement {
    constructor() {
        super();
        this.__firstRun = false;
        this.__preventClose = false;
        this.__mouseOverPopup = false;
    }

    connectedCallback() {
        if (!this.__firstRun) {
            this.__firstRun = true;

            this.__setupHoverTable();
            console.log("BoundPopupFor: connectedCallback()");
        }
    }

    __setupHoverTable() {
        const parent = this.parentElement;
        parent.removeChild(this);

        // this will trigger another connectedCallback() -> that is why we need the firstRun variable
        document.body.appendChild(this);

        const timeoutPopup = () => {
            setTimeout(this.__hide.bind(this), 200);
        };

        // on parent-element hover show the content and hide after few seconds
        parent.addEventListener("mouseenter", (e) => this.__positionHoverTable(parent));
        parent.addEventListener("mouseleave", timeoutPopup);

        // keep the content in view as long as the mouse is inside
        this.addEventListener("mouseenter", () => {
            this.__mouseOverPopup = true;
        });
        this.addEventListener("mouseleave", (e) => {
            /**
             * This is a fix for #990 where card-type could not be changed.
             * Teh reason is that FF fires a "mouseleave" event if you open a dropdown element.
             * We end up here and close the popup eventually.
             * I don't know why this fix works. It is motivated by: https://stackoverflow.com/a/56101092/3719415
             */
            if (e.relatedTarget == null) {
                console.log("skip mouseleave because it is a select element");
                return;
            }

            console.log("Hide ", e.relatedTarget);
            this.__mouseOverPopup = false;
            this.__hide();
        });
    }

    __positionHoverTable(parent) {
        if (!preventOpening) {
            let positionTable = util.boundingClientRelToBody(parent);
            if (this.classList.contains("hover-right")) {
                this.style.right = (document.body.clientWidth - positionTable.right).toString() + "px";
            } else {
                this.style.left = Math.max(0, positionTable.left - 10).toString() + "px";
            }
            this.style.top = Math.max(0, positionTable.top - 10).toString() + "px";
            this.style.minWidth = (20 + positionTable.right - positionTable.left).toString() + "px";
            this.classList.remove("disabled");

            console.log(this.style);
        }
    }

    __setPreventOpening(val) {
        preventOpening = val;
    }

    __hide() {
        if (!this.__mouseOverPopup && !this.__preventClose) {
            this.classList.add("disabled");
        }

        // reset preventClose after override
        this.__preventClose = false;
    }

    overrideCloseOnce() {
        this.__preventClose = true;
    }
}

customElements.define("ldc-hover-popup", BoundPopupFor);

export { BoundPopupFor };
